var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOpen = function SvgOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "open_svg__st0",
    cx: 12,
    cy: 12,
    r: 12
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.73 5.21c.24 0 .47.08.66.25l6.53 5.79c.21.19.34.46.34.75s-.12.56-.34.75L9.4 18.54a.99.99 0 0 1-1.41-.09.997.997 0 0 1 .08-1.41L13.76 12 8.07 6.96c-.41-.37-.45-1-.08-1.41.19-.22.47-.34.74-.34z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgOpen;